import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitLead = (payload) => apiClient.post("/leads", payload).then((r) => r.data);
export const submitCareer = (formData) =>
  apiClient
    .post("/careers", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
export const fetchBlogPosts = () => apiClient.get("/blog/posts").then((r) => r.data);
export const fetchBlogPost = (slug) => apiClient.get(`/blog/posts/${slug}`).then((r) => r.data);
